import xs from "xstream"
import {div, br, label, input, button, p} from "@cycle/dom"
import {intersperse} from 'ramda'

import {LoginForm} from "../../interface"
import {RESERVATION_DONE_MSG} from "../../constant"

const parseMemo = memo => intersperse(br(), memo.split(/\r*\n/))

export const view = (msg$, email$) => {
	return xs.combine(msg$, email$)
		.map(([msg, {mailAddress}]:[string, any]) => {
			const disabled = mailAddress ? "" : ".disabled"
			return div([
					div(".row", [
							p(".mb-1", ["◆日本生殖医学会にご登録されたメールアドレスを入力してください。"]),
							p(["登録されたメールアドレス宛てにパスワードを送信いたします。"])
					]),
					div(".row.mt-2",[
						label(".form-label",{attrs: {for:'email'}},["登録メールアドレス"]),
						div(".col-sm-6",[
							input("#email.form-control", {attrs: {type:"email", placeholder:"メールアドレス", name:'email'}, props: {value: mailAddress}})
						])
					]),
					(msg !== null)
						? div(".col-sm-offset-3.msg",["※",msg])
						: null
						,
					div(".d-grid.gap-2.d-md-flex.mt-4.justify-content-md-start",[
							button(`#btnQuery.btn.btn-primary.col-md-3.${disabled}`, {attrs: {type: "button"}},["問い合わせる"]),
							button("#btnReturn.btn.btn-danger.col-md-3", {attrs: {type: "button"}},["戻る"])
					]),
				])
		})
}
